import { styled } from '@mui/material';

import { EFlightCategory } from '#shared';

import { AircraftDrawer } from '../../AircraftDrawer';
import {
  ZLayersProvider,
  useAircraftSelection,
  useProjectionChangingWithThreshold,
} from '../../data-context';
import { useGeoMap } from '../../GeoMap';
import { OverlayProvider } from '../model';

import { AirportPulseGradient } from './AirportPulseGradient';
import { AviationElements } from './AviationElements';

import type { RefObject } from 'react';

const Root = styled('svg')({
  position: 'absolute',
  top: 0,
  left: 0,
  willChange: 'transform',
  height: '100%',
  width: '100%',

  '&:active': {
    cursor: 'grabbing',
  },
});

export const Overlay = () => {
  const { interactionLayerRef } = useGeoMap();
  const {
    open: isAircraftDrawerOpen,
    selectedAircraft,
    handleClose: handleAircraftDrawerClose,
    handleSelectAircraft,
  } = useAircraftSelection();

  const isProjectionChange = useProjectionChangingWithThreshold({
    rotEpsDeg: 0.35,
    scaleEps: 0.75,
    endDebounceMs: 100,
  });
  const flightCategories = Object.keys(EFlightCategory) as EFlightCategory[];
  return (
    <OverlayProvider onAircraftSelect={handleSelectAircraft}>
      <Root ref={interactionLayerRef as RefObject<SVGSVGElement>}>
        <ZLayersProvider>
          <defs>
            {flightCategories.map(fc => (
              <AirportPulseGradient
                key={fc}
                id={`airport-pulse-gradient-${fc}`}
                flightCategory={fc}
              />
            ))}
          </defs>
          {!isProjectionChange ? <AviationElements /> : null}

          <AircraftDrawer
            open={isAircraftDrawerOpen}
            onClose={handleAircraftDrawerClose}
            aircraftData={selectedAircraft}
          >
            <AircraftDrawer.AircraftEvents />
            <AircraftDrawer.Location />
            <AircraftDrawer.Timeline />
            <AircraftDrawer.Weather />
          </AircraftDrawer>
        </ZLayersProvider>
      </Root>
    </OverlayProvider>
  );
};
